module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-mobile"
  }, [_c('div', {
    staticClass: "wrapper-tab-mobile"
  }, _vm._l((_vm.data), function(item) {
    return _c('div', {
      key: item.id
    }, [_c('div', {
      staticClass: "btn-tab",
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          _vm.$emit('select', item)
        }
      }
    }, [(!item.active) ? _c('span', {
      staticClass: "btn-arrow",
      style: (("color:" + (_vm.globalColors.primary)))
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (item.active) ? _c('span', {
      staticClass: "btn-arrow",
      style: (("color:" + (_vm.globalColors.primary)))
    }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.active) ? _c('div', {
      staticClass: "wrapper-tab-content"
    }, [(item.flag === 'questions') ? _c('div', [_c('form-questions'), _vm._v(" "), _vm._l((_vm.listQuestions), function(question) {
      return _c('wrapper-answer', {
        key: question.id,
        attrs: {
          "data": question
        }
      })
    })], 2) : _vm._e(), _vm._v(" "), (item.flag === 'opinions') ? _c('div', [_c('wrapper-opinions', {
      attrs: {
        "opinions": _vm.opinions
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.flag === 'service') ? _c('div', _vm._l((_vm.select.subSections), function(subSection) {
      return _c('content-text', {
        key: subSection.id,
        attrs: {
          "content": subSection
        }
      })
    })) : _vm._e()]) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f76f670a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabProductMobile.vue
// module id = 1165
// module chunks = 1